// extracted by mini-css-extract-plugin
export default {"form":"form__xb3yI31EB8nQTzS33KaJ","title":"title__qcgxPzg0H0GMRHHGzWfY"};